import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import BackgroundWave from "../../assets/Maskgroup1.png";
import { useNavigate } from "react-router-dom";

const HeroBanner = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    navigate("/landing-page");
  };

  return (
    <Container maxWidth="xl" sx={{ my: 8, pb: 8, px: { xs: 2, md: 10 } }}>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: 9,
          px: { xs: 3, md: 6 },
          py: { xs: 5, md: 8 },
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          minHeight: "200px",
          background: `#4b40d7 url(${BackgroundWave})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* ✅ Gradient light effects */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "300px",
            height: "300px",
            background:
              "radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent 70%)",
            borderRadius: "50%",
            transform: "translate(50%, -50%)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "400px",
            height: "400px",
            background:
              "radial-gradient(circle at bottom left, rgba(255,255,255,0.2), transparent 70%)",
            borderRadius: "50%",
            transform: "translate(-50%, 50%)",
          }}
        />

        {/* ✅ Headline Text */}
        <Typography
          component="h1"
          sx={{
            fontWeight: 700,
            mb: 2,
            maxWidth: { xs: "100%", md: "70%" },
            fontSize: { xs: "28px", sm: "34px", md: "42px", lg: "50px" },
            lineHeight: { xs: 1.2, md: 1.3 },
          }}
        >
          Ready to Transform Your <br /> Customer Support?
        </Typography>

        {/* ✅ Subheading */}
        <Typography
          sx={{
            fontWeight: 400,
            mb: 4,
            fontSize: { xs: "16px", sm: "18px", md: "22px" },
          }}
        >
          Start Free — No Credit Card Needed.
        </Typography>

        {/* ✅ Button */}
        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            backgroundColor: "white",
            color: "#000000ff",
            fontWeight: 800,
            textTransform: "none",
            "&:hover": { backgroundColor: "#f2f2f2" },
            borderRadius: 4,
            fontSize: { xs: 16, md: 18 },
            px: { xs: 3, md: 4 },
            py: { xs: 1.2, md: 1.5 },
          }}
        >
          Book a Free Demo Now!
        </Button>
      </Box>
    </Container>
  );
};

export default HeroBanner;
